Ext.define('SA.data.AttributesQuery', {
    alias: 'query.attributes',
    extend: 'SA.data.Query',

    statics: {
        getLatestEditionPredicate({countryCode, censusReleaseYear}) {
            var datasets = SA.data.Vendors.getDatasetModels()
                .filter(dataset => !dataset.isImport())
                .filter(dataset => dataset.hasCountryCode(countryCode))
                .filter(dataset => dataset.hasCensusReleaseYear(censusReleaseYear));

            return [
                'or',
                ...datasets.map(dataset => {
                    return [
                        'and',
                        ['=', 'dataset_series', dataset.getId()],
                        ['=', 'year', dataset.getLatestEditionForCensusReleaseYear(censusReleaseYear)]
                    ];
                })
            ];
        },

        getCountryAndStatusVisiblePredicate(country, censusRelease) {
            var query;

            if (typeof country === 'string') {
                country = SA.Institution.getCountry(country);
            }

            query = [
                'and',
                ['=', 'status', 'visible'],
                ['=', 'country', country.getCode()]
            ];

            if (censusRelease) {
                query.push(['=', 'censusRelease', censusRelease]);
            }

            return query;
        },

        getCountryAndStatusVisiblePredicateyWithTreeStatusOverride(country, censusRelease) {
            var query = this.getCountryAndStatusVisiblePredicate(country, censusRelease),
                statusTermIndex = query.findIndex(term => SA.arraysEqual(term, ['=', 'status', 'visible']));

            query.splice(statusTermIndex, 1, [
                'or',
                ['=', 'status', 'visible'],
                ['=', 'overrideTreeStatus', 'visible']
            ]);

            return query;
        }
    },

    fieldsProperty: 'fields',
    resource: 'attributes',
    whereProperty: 'where',

    createParams() {
        var params = this.callParent();

        if (this.userData) {
            params.data.userData = true;
        }

        if (this.acsOnly) {
            this.where.push(['=', 'dataset_series', SA.DatasetIds.ACS]);
        }

        if (this.scarboroughCrosstabOnly) {
            this.where.push(['=', 'dataset_series', SA.DatasetIds.ScarboroughCrosstab]);
        }

        if (this.simmonsCrosstabOnly) {
            this.where.push(['in', 'dataset_series', [SA.DatasetIds.MRISimmonsCrosstab, SA.DatasetIds.SimmonsCrosstab]]);
        }

        return params;
    }
});